import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import ButtonDefault, { ButtonVariant } from "~/src/components/Button/ButtonDefault";
import { Header, TextVariant } from "~/src/components/Text/Text";
import TomtResultat from "../Oversikt/Components/TomtResultat";

const ErrorPage = (): JSX.Element => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <TomtResultat>
      <Header headerLvl={1} variant={TextVariant.xxxlarge} className="mb-8">
        {t("pages.error.title")}
      </Header>
      <ButtonDefault
        label="Gå tilbake"
        variant={ButtonVariant.Primary}
        id="tilbake"
        onClick={() => navigate(-1)}
      />
    </TomtResultat>
  );
};

export default ErrorPage;
